exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spinner-icon{width:64px;height:64px;margin:0 auto}.spinner-icon .spinner{position:relative;width:64px;height:64px;animation:rotate 2s linear infinite}.spinner-icon .path{stroke-dasharray:1,200;stroke-dashoffset:0;animation:dash 1.5s ease-in-out infinite,colors 6s ease-in-out infinite;stroke-linecap:round}@keyframes rotate{to{transform:rotate(1turn)}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35}to{stroke-dasharray:89,200;stroke-dashoffset:-124}}@keyframes colors{0%{stroke:#0098ce}25%{stroke:#0b4f6c}50%{stroke:#0098ce}75%{stroke:#006494}to{stroke:#0098ce}}.spinner-icon{position:absolute;top:calc(50% - 32px);left:calc(50% - 32px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/styles/loader.scss
// module id = 505
// module chunks = 1